import { UseTransitionProps } from '@react-spring/web';
import { reduxKey } from './constants';

export enum NotificationType {
  Collect,
  CollectUndo,
  AddToGroup,
  AddToGroupUndo,
  Fave,
  FaveUndo,
  DeleteComment,
  PostComment,
  Live,
  Generic,
  GenericUndo,
  Badge,
  CollectPrivate,
  Unpublish,
}

export interface NotificationQueueItem {
  id: number;
  queueName: string;
  type: string | NotificationType;
  created: number;
  params: any;
}

export interface NotificationQueueStateSlice {
  default: NotificationQueueItem[];
  [queueName: string]: NotificationQueueItem[];
}

export interface NotificationQueueState {
  [reduxKey]: NotificationQueueStateSlice;
}

export type NotificationRenderFunction = (
  notification: NotificationQueueItem,
  removeNotification: (id: number) => void
) => React.ReactNode;

export type TransitionOptions = UseTransitionProps<NotificationQueueItem>;
